/**
 * Skills Thermometer BAND — how strongly a skill shows (its blended power,
 * 0–100): Power, Strong, Growing or Emerging.
 *
 * Brain usually sends the band with each skill; when it does not, the SERVER
 * grades it with {@link skillPowerBand} and every client draws the band it is
 * sent. journey-web (`getSkillBand`) and citizen-mobile (`_getSkillBand`) each
 * carried a copy of this rule for runs they rebuilt from the raw Brain blob.
 *
 * Lower bounds are INCLUSIVE.
 */

export const CHECKUP_SKILL_BANDS = ['Power', 'Strong', 'Growing', 'Emerging'] as const;
export type CheckUpSkillBand = (typeof CHECKUP_SKILL_BANDS)[number];

export function skillPowerBand(power: number): CheckUpSkillBand {
  if (power >= 90) return 'Power';
  if (power >= 70) return 'Strong';
  if (power >= 40) return 'Growing';
  return 'Emerging';
}

/** A band Brain sent, if it is one of ours; otherwise the band of the power. */
export function resolveSkillBand(sent: unknown, power: number): CheckUpSkillBand {
  return CHECKUP_SKILL_BANDS.find((band) => band === sent) ?? skillPowerBand(power);
}

/** The i18n key of each band — guarded against en.json in dynamic-key-coverage.spec.ts. */
export const CHECKUP_SKILL_BAND_LABEL_KEY = {
  Power: 'checkup.bandLabels.power',
  Strong: 'checkup.bandLabels.strong',
  Growing: 'checkup.bandLabels.growing',
  Emerging: 'checkup.bandLabels.emerging',
} as const satisfies Record<CheckUpSkillBand, string>;
